<div class="p-6 flex flex-col w-full h-full overflow-hidden">
  <div class="flex flex-wrap -mx-2 mb-4">
    <div class="flex-none w-1/6 px-2">
      <p>Name:</p>
    </div>
    <div class="grow shrink-0 basis-0 px-2">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Name</mat-label>
        <input matInput placeholder="Name (Minimum Characters - 5, Maximum Characters - 100)" type="text" [formControl]="nameControl">
      </mat-form-field>
    </div>
  </div>
  <div class="flex flex-wrap -mx-2 mb-4">
    <div class="flex-none w-1/6 px-2">
      <p class="mb-0">Filters:</p>
    </div>
    <div class="grow shrink-0 basis-0 px-2">
      <p class="mb-0">(Please specify at least one filter from Job Level, Department, Title to save the Buyer Persona Group)</p>
    </div>
  </div>
  <div class="flex flex-wrap -mx-2 h-full overflow-hidden">
    <div class="flex-none w-1/3 px-2">
      <p>Level:</p>
      <app-job-level [data]="controlData" [jobLevels]="controlData?.job_levels" (jobLevelsSelection)="onSelectionChanged()"></app-job-level>
    </div>
    <div class="flex-none w-1/3 px-2 flex flex-col h-full overflow-hidden">
      <p>Department:</p>
      <app-job-department class="flex flex-col w-full h-full overflow-hidden" [data]="controlData" (jobDepartmentSelection)="onSelectionChanged()"></app-job-department>
    </div>
    <div class="flex-none w-1/3 px-2">
      <p>Title:</p>
      <app-job-title [data]="controlData" [hideAdvancedSwitch]="true" [hideTitle]="true" (titleChanged)="onSelectionChanged()"></app-job-title>
    </div>
  </div>
</div>
